export enum DIReason {
  ENTRY_CREDIT_FAIL,
  ENTRY_CREDIT_PROXIMITY_FAIL,
  MODIFY_CREDIT_FAIL,
  MODIFY_CREDIT_PROXIMITY_FAIL,
  CREDIT_CANCEL_FAIL,
  CREDIT_CANCEL_TIMEOUT,
  CREDIT_REJECT_FAIL,
  CREDIT_REJECT_TIMEOUT,
  CREDIT_EXPIRY_FAIL,
  CREDIT_EXPIRY_TIMEOUT,
  FILL_CREDIT_FAIL,
  DAILY_REVAL_CREDIT_FAIL,
  PROXIMITY_REVAL_CREDIT_FAIL,
  FORCE_TO_DI,
  SOFT_CUT_OFF,
  CANCEL_DURING_SOFT_CUT_OFF,
  FIXING_RATE_REQUIREMENT,
  FILL_WITHELD,
  FILL_NOT_RECEIVED,
  FILL_FWD_ROLL_NOT_RECEIVED,
  PORTFOLIO_FWD_ROLL,
  PORTFOLIO_FWD_ROLL_SAVED,
  PORTFOLIO_FWD_ROLL_ERROR,
  PORTFOLIO_FWD_ROLL_AUTO_SAVED,
}

export namespace DIReason {
  let elements = [
    DIReason.ENTRY_CREDIT_FAIL,
    DIReason.ENTRY_CREDIT_PROXIMITY_FAIL,
    DIReason.MODIFY_CREDIT_FAIL,
    DIReason.MODIFY_CREDIT_PROXIMITY_FAIL,
    DIReason.CREDIT_CANCEL_FAIL,
    DIReason.CREDIT_CANCEL_TIMEOUT,
    DIReason.CREDIT_REJECT_FAIL,
    DIReason.CREDIT_REJECT_TIMEOUT,
    DIReason.CREDIT_EXPIRY_FAIL,
    DIReason.CREDIT_EXPIRY_TIMEOUT,
    DIReason.FILL_CREDIT_FAIL,
    DIReason.DAILY_REVAL_CREDIT_FAIL,
    DIReason.PROXIMITY_REVAL_CREDIT_FAIL,
    DIReason.FORCE_TO_DI,
    DIReason.SOFT_CUT_OFF,
    DIReason.CANCEL_DURING_SOFT_CUT_OFF,
    DIReason.FIXING_RATE_REQUIREMENT,
    DIReason.FILL_WITHELD,
    DIReason.FILL_NOT_RECEIVED,
    DIReason.FILL_FWD_ROLL_NOT_RECEIVED,
    DIReason.PORTFOLIO_FWD_ROLL,
    DIReason.PORTFOLIO_FWD_ROLL_SAVED,
    DIReason.PORTFOLIO_FWD_ROLL_ERROR,
    DIReason.PORTFOLIO_FWD_ROLL_AUTO_SAVED,
  ];
  let alias = "com.bcdfx.model.DIReason";

  export function RemoteClass() {
    return alias;
  }

  export function getAllElements() {
    return elements;
  }
}
